<template>
  <div>
    <div id="content" class="content" style="margin-left:0px;">
      <h1 class="page-header" style="text-align:left">
        服务商管理
        <small>/&nbsp;服务商列表</small>
      </h1>

      <div
        id="page-container"
        class="in page-sidebar-fixed page-header-fixed"
        style="padding-top:0px;"
      >
        <!-- begin #content -->
        <div
          id="content"
          class="content"
          style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
        >
          <!-- begin breadcrumb -->

          <div class="row">
            <!-- begin col-10 -->
            <div class="col-lg-12">
              <!-- begin panel -->
              <div class="panel panel-inverse">
                <!-- begin panel-heading -->
                <div class="panel-heading">
                  <div class="panel-heading-btn">
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-default"
                      data-click="panel-expand"
                    >
                      <i class="fa fa-expand"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-success"
                      data-click="panel-reload"
                    >
                      <i class="fa fa-redo"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-warning"
                      data-click="panel-collapse"
                    >
                      <i class="fa fa-minus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-danger"
                      data-click="panel-remove"
                    >
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                  <h4 class="panel-title panelTitle">服务商列表</h4>
                </div>
                <!-- end panel-heading -->
                <!-- begin panel-body -->
                <div class="panel-body">
                  <form
                  
                    style="margin-top:16px;padding-left:15px;"
                  >
                    <fieldset>
                      <div class="form-group row m-b-15">
                        <label class="col-md-1 col-form-label">服务商名称</label>
                        <div class="col-md-2">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="服务商名称"
                            v-model="recomName"
                          >
                        </div>
                        <label class="col-md-1 col-form-label">分组名称</label>
                        <div class="col-md-2">
                          <v-selectpage :data="RecomOptions" key-field="groupId" show-field="groupName" v-model="groupId" placeholder="请选择分组名称" title=""></v-selectpage>
                        </div>
                        <div class="col-md-1">
                          <a
                            class="btn btn-primary ButtonColor m-r-5"
                            @click="SearchClick()"
                            style="float:right;"
                          >查询</a>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                  <el-table :data="UserManagementList" border style="width: 100%">
                    <el-table-column prop="ordernumber" label="序号"  width="60" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="recom" label="服务商渠道号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="recomName" label="服务商名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="groupName" label="分组名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="domainUrl" label="域名地址" width="500" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="门店数量" width="120" align="center">
                      <template slot-scope="scope" v-if="scope.row.isO2OShopOpen == 1">
                        <span>{{scope.row.shopCount}}</span>
                        <el-button @click="SelectShops(scope.row)" type="text">
                          [查看设置]
                        </el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="设置" width="120" align="center">
                      <template slot-scope="scope" v-if="scope.row.isPCMallOpen == 1">
                        <el-button type="text" @click="SettingShop(scope.row)">商城管理</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100" align="center" fixed="right">
                      <template slot-scope="scope">
                        <a
                          class="btn btn-primary btn-sm ButtonColor"
                          data-toggle="modal"
                          @click="DetailClick(scope.row)"
                        >详情</a>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="PaginationStyle">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="pageindex"
                      :page-sizes="[10,20,50,100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      background
                      :total="totalCount"
                    ></el-pagination>
                  </div>
                </div>
                <!-- end panel-body -->
              </div>
              <!-- end panel -->
            </div>
            <!-- end col-10 -->
          </div>
          <!-- end row -->
        </div>
        <!-- end #content -->
      </div>
      <el-dialog title :visible.sync="outerVisible" width="500px" >
        <div v-if="EditDialog === 2" class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">您确定吗?</div>
          <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled = 'disabled'>确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>
      
      </el-dialog>
    </div>
  </div>
  
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "BrandManagement",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      EditDialog: 1,
      CurrentSelection: [],
      disabled: false,
      groupId: "",
      recomName:'',
      UserManagementList: [],
      RecomOptions:[]
    };
  },
  mounted: function() {
    if (this.$route.params && this.$route.params.searchContent) {
      this.groupId = this.$route.params.searchContent.groupId;
      this.recomName = this.$route.params.searchContent.recomName;
    }
    this.initdata();
    this.getRecomList();
  },
  watch:{
    pageNo: {
    　　handler(newName, oldName) {
            if(this.$route.params && this.$route.params.pageNo){
    
               this.pageNo = this.$route.params.pageNo
            }
           
       　　},
    　　immediate: true
    },
    pagesize:{
      　handler(newName, oldName) {
            if(this.$route.params && this.$route.params.pagesize){
               this.pageSize = this.$route.params.pagesize
            }
           
       　　},
    　　immediate: true
    }
  },
  computed: {
      pageNo:{
        set(val){ 
          if(val){
            
             this.pageindex = val
          }

        },
        get(){
          //console.log('我被调用了') //msg1获取值时触发
       
        },
      },
      pagesize:{
        set(val){ 
          if(val){
             this.pageSize = val
          }

        },
        get(){
          //console.log('我被调用了') //msg1获取值时触发
       
        }
      }
  },
  methods: {
    DetailClick(row) {
      let searchContent = {};
      searchContent.groupId = this.groupId;
      searchContent.recomName = this.recomName;
      this.$router.push({ path: "/distributordetail" });
      localStorage.setItem("goodlist", JSON.stringify({recomId:row.recomId,pageNo: this.pageindex,pageSize: this.pageSize,searchContent: searchContent}));
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    EditClick(row) {
      this.$router.push({ path: "/editdistributor" });
      localStorage.setItem("goodlist", JSON.stringify({recomId:row.recomId,pageNo: this.pageindex,pageSize: this.pageSize}));
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    AddClick() {
       this.$router.push({ path: "/adddistributor" });
       localStorage.setItem("goodlist", JSON.stringify({pageNo: this.pageindex,pageSize: this.pageSize}));
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
      const options = {
        url: "distribution/B2cRecomInfoController/deleteRecomInfo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomType: that.CurrentSelection.recomType,
          recomId: that.CurrentSelection.recomId,
        })
      };
      axios(options).then(function(response) {
        that.disabled = false;
        that.outerVisible = false;
        that.initdata();
        if (response.data.code == 200) {
          that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
        } else {
            http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          that.disabled = false;
          that.outerVisible = false;
          http.handleHttpError(error, that);
        });
    },
    initdata() {
     let that = this;
      const options = {
        url: "distribution/B2cRecomInfoController/queryRecomInfoByPage",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          groupId: that.groupId,
          recomName: that.recomName,
          size: that.pageSize,
          current: that.pageindex
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          for (var i in response.data.data.data) {
            response.data.data.data[i].ordernumber =
            Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
          }
          that.totalCount = response.data.data.totalCount;
          that.UserManagementList = response.data.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      }).catch((error) => {
        http.handleHttpError(error, that);
      });
    },
    // 获取分组
    getRecomList() {
      let that = this;
      const options = {
        url: "distribution/B2cGroupInfoController/queryAllGroup",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.RecomOptions = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    // 查看门店
    SelectShops(row){
      this.$router.push({ 
        path: "/storelist",
        query: {recomId:row.id}
      });
    },
    // 商城设置
    SettingShop(row){
      this.UserManagementList.forEach(element=>{
        element.disabled = false;
      })
      row.disabled = true;
      let href = this.$router.resolve({ 
        path:'/mallsettingmenu',
        name:'MallSettingMenu',
        query: {recomId:row.recomId}
      });
      window.open(href.href, '_blank');
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth{
  width:202px;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/CustomerService.vue